import { render, staticRenderFns } from "./MemberData.vue?vue&type=template&id=2b977235&"
import script from "./MemberData.vue?vue&type=script&lang=js&"
export * from "./MemberData.vue?vue&type=script&lang=js&"
import style0 from "./MemberData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports